module.exports = __webpack_public_path__ + "img/Invasion-OVCA_10X_WTA.313a32ed.png";